import { defaultApiState } from '../api.state';

export const advisorState = {
  apiState: {
    getAdvisors: defaultApiState,
    getAdvisor: defaultApiState,
    deleteAdvisor: defaultApiState,
    addAdvisor: defaultApiState,
    updateAdvisor: defaultApiState,
    getAdvisorAppointmentConfig: defaultApiState,
    updateAdvisorAppointmentConfig: defaultApiState,
  },
  advisors: [],
  advisor: undefined,
  advisorAppointmentConfig: {},
};
